// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"8":"editor","914":"preload"}[chunkId] || chunkId) + "." + {"8":"58ad393e","914":"cec8aab8","963":"31d6cfe0"}[chunkId] + ".chunk.css";
};